
import appAjax from './ajax';
import $ from 'jquery';

export default {
  HB: null,
  isInitialized: null,
  timestampPing: null,
  htmlStatus: null,
  updateWsStatus(htmlStatus) {
    if (htmlStatus) this.htmlStatus = htmlStatus;
    $('.ws_status').html(this.htmlStatus);
  },
  initWebsocket(token, onSuccess) {
    if (!appAjax.CONN) {
      //conn = new WebSocket('ws://127.0.0.1:8080?user=guest&exp=0');
      //conn = new WebSocket('wss://api.undip.cc/ws');
      // appAjax.CONN = new WebSocket(appAjax.wsBaseUrl + "?user=guest&exp=0");
      appAjax.CONN = new WebSocket(appAjax.wsBaseUrl + "?token="+token);
      appAjax.CONN.onopen = (e) => {
        // var newLine = $('<div class="media media-meta-day" />').text("Connection established!").appendTo(appAjax.CHATBOX);
        this.updateWsStatus("<i class='fa fa-check-square'></i> Connected");
        $(appAjax.CHATBOX).prop({ scrollTop: $(appAjax.CHATBOX).height() });

        console.log("Connection established!");

        //-- Authentication
        // appAjax.CONN.send('@join');

        //-- Send hearbeat every 10 secs
        this.HB = setInterval(() => {
          // if (appAjax.CONN) appAjax.CONN.send('@ping');
          this.timestampPing = new Date().getTime();
          if (appAjax.CONN) appAjax.CONN.send(JSON.stringify({ "type": "ping" }));
        }, 10000);

        this.timestampPing = new Date().getTime();
        if (appAjax.CONN) appAjax.CONN.send(JSON.stringify({ "type": "ping" }));

        onSuccess();
      };

      appAjax.CONN.onmessage = (e) => {
        //var newLine = $('<div />').text(e.data).appendTo(appAjax.CHATBOX);

        try {
          const objMessage = JSON.parse(e.data);
          if (objMessage.type == 'pong') {
            if (this.timestampPing) {
              var pingTime = new Date().getTime() - this.timestampPing;
              $('.ws_ping').text(pingTime + ' ms');
            }
            return;
            
          } else if (objMessage.type == 'notification') {
            var newLine = $('<div class="media media-meta-day" />').text(objMessage.content).appendTo(appAjax.CHATBOX);
            
          } else {
            var sender = 'sender' in objMessage ? objMessage.sender : 'Unknown';
            appAjax.addBubble(objMessage.content + '', sender);
          }

        } catch (error) {
          
        }

        // if (e.data[0] == '@') {
        //   if (e.data == '@ping') return;
        //   if (e.data == '@pong') return;
        //   var newLine = $('<div class="media media-meta-day" />').text(e.data).appendTo(appAjax.CHATBOX);

        // } else {
        //   appAjax.addBubble(e.data + '');
        // }

        $(appAjax.CHATBOX).prop({ scrollTop: $(appAjax.CHATBOX).prop('scrollHeight') });
      };

      appAjax.CONN.onclose = (e) => {
        console.log("The connection has been closed.");
        var newLine = $('<div class="media media-meta-day" />').text("Connection closed.").appendTo(appAjax.CHATBOX);

        var htmlReloadButton = '<button class="btn btn-primary" onclick="window.location.reload();"><i class="fa fa-sync"></i> Reload</button>';
        var reloadButton = $('<div class="media media-meta-day" />').html(htmlReloadButton).appendTo(appAjax.CHATBOX);
        $(appAjax.CHATBOX).prop({ scrollTop: $(appAjax.CHATBOX).height() });

        $('#chatform').find('[type=submit]').attr('disabled', 'disabled');
        $("#chatinput").attr('disabled', 'disabled');

        //-- Change send button to reload icon
        $('.publisher-btn i').removeClass('fa-paper-plane').addClass('fa-ban');

        this.updateWsStatus("<i class='fa fa-times'></i> Disconnected");

        appAjax.CONN = null;
      };

      appAjax.CONN.onerror = function (e) {
        console.log("Connection error!");
        var newLine = $('<div class="media media-meta-day text-danger" />').text("Connection error!").appendTo(appAjax.CHATBOX);
        $(appAjax.CHATBOX).prop({ scrollTop: $(appAjax.CHATBOX).height() });

        $('#chatform').find('[type=submit]').attr('disabled', 'disabled');
        $("#chatinput").attr('disabled', 'disabled');

        appAjax.CONN = null;
      };
    } // End if (!appAjax.CONN)
  },
}
